import axios from "axios";
import { setUser, setLoading } from "../reducers/authentication";
import { AppThunk } from "../redux/store";
import { Claim } from "../typeDefs/userprofiles";

export const getUserProfile = (): AppThunk<void> => (dispatch) => {
    dispatch(setLoading(true));
    axios
        .get<Claim[]>("api/user-profiles/my")
        .then((res) => {
            if (!res.data || res.data.length === 0)
                window.location.href = "/Account/Login";

            const permissions: string[] = res.data
                .filter((claim) => claim.Type.startsWith("permission"))
                .map((claim) => claim.Value);

            const claims: any = res.data
                .filter((claim) => !claim.Type.startsWith("permission"))
                .reduce<any>(
                    (prev: Claim, curr: Claim) => ({
                        ...prev,
                        [curr.Type]: curr.Value,
                    }),
                    {
                        permissions,
                    }
                );

            dispatch(setUser(claims));
            dispatch(setLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setLoading(false));
            window.location.href = "/Account/Login";
        });
};

export const ping = () => {
    axios
        .get("api/ping")
        .then((res) => {
            // do nothing
        })
        .catch((err) => {
            console.error(err);
            window.location.href = "/Account/Logout";
        });
};
